import React, { Component } from 'react';

import AuthService from './AuthService';
import constants from '../config';

const Auth = new AuthService();

class ShopSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopActive: true,
      loading: true,
      saving: false,
      toast: '',
    };
    this.handleToggle = this.handleToggle.bind(this);
  }

  componentDidMount() {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/users/' + this.props.user._id, {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      self.setState({
        shopActive: res.profile.shopActive !== false,
        loading: false,
      });
    }).catch(function(err) {
      console.log(err);
      self.setState({ loading: false });
    });
  }

  handleToggle() {
    var self = this;
    var newValue = !this.state.shopActive;
    this.setState({ saving: true });
    var body = new URLSearchParams();
    body.append('shopActive', newValue);
    Auth.fetch(constants.DOMAIN + '/api/v1/users/profile', {
      mode: 'cors',
      method: 'PATCH',
      body: body,
    }).then(function() {
      self.setState({
        shopActive: newValue,
        saving: false,
        toast: newValue ? 'Shop is now open' : 'Shop is now closed',
      });
      setTimeout(function() { self.setState({ toast: '' }); }, 3000);
    }).catch(function(err) {
      console.log(err);
      self.setState({ saving: false });
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="tw-flex tw-items-center tw-justify-center tw-py-12">
          <div className="tw-animate-spin tw-rounded-full tw-h-8 tw-w-8 tw-border-t-2 tw-border-b-2 tw-border-brand-gold"></div>
        </div>
      );
    }

    var shopActive = this.state.shopActive;

    return (
      <div>
        <h2 className="tw-text-xl tw-font-bold tw-text-[#111] dark:tw-text-white tw-mb-6">Shop</h2>

        <div className="tw-bg-white dark:tw-bg-[#1a1a1a] tw-rounded-xl tw-border tw-border-[#e0e0e0] dark:tw-border-[#333] tw-p-6">
          <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
            <div>
              <h3 className="tw-text-base tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-1">Shop Status</h3>
              <p className="tw-text-sm tw-text-[#666] dark:tw-text-[#999] tw-mb-0">
                {shopActive
                  ? 'Your shop is open. Listings appear in search results and browse feeds.'
                  : 'Your shop is closed. Listings are hidden from search and browse. Existing orders are not affected.'}
              </p>
            </div>
            <button
              onClick={this.handleToggle}
              disabled={this.state.saving}
              className="tw-flex-shrink-0 tw-relative tw-w-14 tw-h-8 tw-rounded-full tw-border-none tw-cursor-pointer tw-transition-colors tw-duration-200"
              style={{ backgroundColor: shopActive ? '#c9a84c' : '#555' }}
              aria-label={shopActive ? 'Close shop' : 'Open shop'}
            >
              <span
                className="tw-absolute tw-top-1 tw-w-6 tw-h-6 tw-bg-white tw-rounded-full tw-shadow tw-transition-all tw-duration-200"
                style={{ left: shopActive ? '28px' : '4px' }}
              />
            </button>
          </div>

          <div className="tw-mt-4 tw-pt-4" style={{ borderTop: '1px solid #e5e5e5' }}>
            <div className="tw-flex tw-items-center tw-gap-2">
              <span
                className="tw-w-2.5 tw-h-2.5 tw-rounded-full tw-flex-shrink-0"
                style={{ backgroundColor: shopActive ? '#16a34a' : '#ef4444' }}
              />
              <span className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white">
                {shopActive ? 'Open' : 'Closed'}
              </span>
            </div>
          </div>
        </div>

        <p className="tw-text-xs tw-text-[#999] dark:tw-text-[#666] tw-mt-4">
          When your shop is closed, your listings won't appear in search results, browse feeds, or card detail pages. Your profile page will still show your listings with a "Shop Closed" notice. Direct links to your products will still work but buy buttons will be disabled. Existing orders and transactions are not affected.
        </p>

        {/* Toast */}
        {this.state.toast ? (
          <div
            className="tw-fixed tw-bottom-6 tw-left-1/2 tw-z-50 tw-px-5 tw-py-3 tw-rounded-lg tw-shadow-lg tw-text-sm tw-font-medium tw-text-white"
            style={{ transform: 'translateX(-50%)', backgroundColor: '#1a1a1a' }}
          >
            {this.state.toast}
          </div>
        ) : null}
      </div>
    );
  }
}

export default ShopSettings;
